<template>
  <div>
    <el-form ref="formRef" :model="sysForm" label-width="auto">
      <el-form-item label="名称：">
        <div style="display: flex; justify-content: space-between; width: 100%;">
          <el-input v-model="sysForm.name" placeholder="请输入名称" />
          <el-select
              v-model="selectName"
              filterable
              default-first-option
              placeholder="选择名称"
              style="width: 11em;margin-left: 8px;"
              @change="selectChange"
          >
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="url：">
        <el-input v-model="sysForm.url" placeholder="请输入url" />
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="sysForm.orderNum" placeholder="请输入排序" />
      </el-form-item>

      <el-form-item v-if="sysForm.level == 1">
        <el-collapse accordion style="width: 100%">
          <el-collapse-item name="1">
            <template #title>
              <ElIcons v-if="sysForm.css" :name="sysForm.css" size="20" style="margin-right: 10px"/>
              标题图标
            </template>
            <el-scrollbar height="300px">
              <div style="display: flex; flex-wrap: wrap">
                <div v-for="item of elementIcons" :key="item" class="iconBtn" @click="changeIcon(item)">
                  <ElIcons :name="item" size="20"/>
                </div>
              </div>
            </el-scrollbar>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>

<!--      <el-form-item label="级别：">-->
<!--        <el-input v-model="sysForm.level" placeholder="请输入级别" />-->
<!--      </el-form-item>-->
<!--      <el-form-item label="父级ID：">-->
<!--        <el-input v-model="sysForm.preId" placeholder="请输入父级ID" />-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postJson } from "@/api/api"
import { addOrUpdateMenuList } from "@/api/url";
import elementIcons from "@/assets/shared/element-icons";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     sysForm: this.value.sysForm,
     idx: this.value.index,
     routes: this.value.routes,
     options: [],
     elementIcons,
     showIcons: false,
     selectName: '',
   }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    changeIcon(iconName) {
      this.sysForm.css = iconName
    },

    selectChange(val) {
      this.sysForm.name = val
      for(let i=0; i<this.options.length; i++) {
        if(this.options[i].label == val) {
          this.sysForm.url = this.options[i].url
        }
      }
    },

    getOptions() {
      let routeList = this.routes
      for (let i=0; i<routeList.length; i++) {
        if (routeList[i].children && routeList[i].path != '/home') {
          for (let j=0; j<routeList[i].children.length; j++) {
            let obj = {}
            obj.label = routeList[i].children[j].meta.title
            obj.value = routeList[i].children[j].meta.title
            obj.url = routeList[i].path + '/' + routeList[i].children[j].path
            this.options.push(obj)
          }
        }
      }
      // console.log(this.options)
    },

    summit() {
      if(!this.sysForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.sysForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx <= 0?0:this.sysForm.id;
      param['url'] = this.sysForm.url;
      param['name'] = this.sysForm.name;
      param['css'] = this.sysForm.css;
      param['orderNum'] = this.sysForm.orderNum;
      param['preId'] = this.sysForm.preId;
      param['level'] = this.sysForm.level;
      param['isDel'] = 0;
      postJson(addOrUpdateMenuList, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }
  },
  mounted() {
    this.getOptions()
    console.log(elementIcons)
  }
}
</script>

<style scoped>
.iconBtn {
  padding: 8px;
  cursor: pointer;
}
.iconBtn:hover {
  background-color: #f5f7fa;
}
</style>
